import gql from 'graphql-tag';

export default gql`
  mutation EditManualActivity($input: DailyTrackerEditManualActivityInputType!) {
    dailyTracker {
      editManualActivity(input: $input) {
        ... on DailyTrackerEditManualActivitySuccess {
          activity {
            id
            name
            sourceType
            activityType
            activityTypeName
            caloriesBurned
            durationSeconds
            loggedAt
            distance
            distanceUnit
          }
        }
        ... on ValidationException {
          validationCode: code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on UnauthorizedException {
          unauthorizedCode: code
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
